const linkCheck = new RegExp('^http(s)://', 'i')

type TKeyValue = Record<string, string>
type TKeyValueSet = Record<string, TKeyValue>

const normalizeUrlPart = (value = '') => value.replace(/\/\.\//g, '/').replace(/^\.\//, '')

const normalizeBase = (base = '') => {
  const sanitized = normalizeUrlPart(base.trim())
  if (!sanitized) return ''
  return sanitized.endsWith('/') ? sanitized.slice(0, -1) : sanitized
}

const normalizeLink = (link = '') => {
  const sanitized = normalizeUrlPart(link.trim())
  if (!sanitized) return ''
  return sanitized
}

export const getKeyValueSet = (
  keyValue: TKeyValueSet = { default: {} },
  vendorKey: null | string = null
): TKeyValue => {
  let resKeyValue = keyValue?.default || {}

  if (keyValue && !!vendorKey && keyValue[vendorKey]) {
    resKeyValue = Object.assign(keyValue?.default || {}, keyValue[vendorKey] || {})
  }

  return Object.entries(resKeyValue).reduce<TKeyValue>((acc, [key, url]) => {
    if (!!url) acc[key] = url
    return acc
  }, {})
}

export const getAssetUrl = (link = '', baseAssetsUrl = '') => {
  const normalizedLink = normalizeLink(link)
  if (!normalizedLink) return ''

  if (linkCheck.test(normalizedLink) || normalizedLink.startsWith('data:') || normalizedLink.startsWith('blob:')) {
    return normalizedLink
  }

  const normalizedBase = normalizeBase(baseAssetsUrl)
  if (!normalizedBase) {
    if (normalizedLink.startsWith('/')) return normalizedLink
    return `./${normalizedLink}`
  }

  const baseHasAssets = /\/assets$/i.test(normalizedBase)
  const linkHasAssets = /^\/assets\//i.test(normalizedLink)
  const finalLink = baseHasAssets && linkHasAssets ? normalizedLink.replace(/^\/assets/i, '') : normalizedLink

  return `${normalizedBase}${finalLink}`
}

export const prepareAssets = (assets: TKeyValue = {}, baseAssetsUrl = ''): TKeyValue => {
  return Object.entries(assets).reduce<TKeyValue>((acc, [key, path]) => {
    acc[key] = getAssetUrl(path, baseAssetsUrl)
    return acc
  }, {})
}
